<template>
  <div>
    <search-bar
      @search="onSearch"
      name="md_prodcode,mp.pr_detail"
      placeholder="输入产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-cell" v-for="item in items" :key="item.md_id">
        <div class="weui-cell__bd">
          <p>{{item.md_code}} #{{item.dd_detno}}</p>
          <p class="list-item-muted">{{item.md_prodcode}} {{item.maprdetail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>
            <span v-format="'#,##0.#'">{{item.md_qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p class="list-item-muted" v-if="item.md_havegetqty">
            已领:&nbsp;
            <span v-format="'#,##0.#'">{{item.md_havegetqty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p v-if="item.dd_scrapqty" class="list-item-muted">
            报废:&nbsp;
            <span v-format="'#,##0.#'" class="text-error">{{item.dd_scrapqty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p v-if="item.dd_losstotal" class="list-item-muted">
            损耗金额:&nbsp;
            <span v-format="'#,##0.#'" class="text-error">{{item.dd_losstotal}}</span>
            &nbsp;
          </p>
          <p class="list-item-muted">
            损耗率:&nbsp;
            <span class="text-error" v-format="'#0.##'">{{item.dd_lossrate || 0}}</span>
          </p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/makeCutLoss",
      params: {
        mode: "DETAIL"
      },
      filters: [
        {
          type: "date",
          name: "make_disassemble.createTime"
        }
      ]
    };
  },
  mounted() {
    this.doSearch()
  }
};
</script>